import { Component } from '@verndale/core';
import Swiper from 'swiper';
import { Navigation, Keyboard, Pagination, Controller } from 'swiper/modules';
import { isSmallDesktop } from '../helpers';
import { eventBus } from '../helpers/resize';
import 'swiper/css/bundle';

class slidingCardContainer extends Component {
  public slidingCardContainer: { destroy?: () => void | undefined };

  constructor(el: HTMLElement) {
    super(el);
    this.slidingCardContainer = {};
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      swiperContainer: this.el.querySelector<HTMLElement>('.swiper'),
      swiperWrapper: this.el.querySelector<HTMLElement>('.swiper-wrapper'),
      swiperItems: this.el.querySelectorAll<HTMLElement>('.swiper-slide'),
      pagination: this.el.querySelector<HTMLElement>('.sliding-card__slider-pagination'),
      prevButton: this.el.querySelector<HTMLElement>('.btn-previous-slide'),
      nextButton: this.el.querySelector<HTMLElement>('.btn-next-slide')
    };

    if (!isSmallDesktop()) {
      this.initSwiper();
    } else {
      (this.dom.swiperItems as NodeList).forEach(item => {
        (item as HTMLElement).classList.remove('swiper-slide');
      });
    }
  }

  addListeners() {
    eventBus.subscribe('breakpointChange', (breakpoint: string) => {
      this.manageSwiper(breakpoint);
    });
  }

  manageSwiper(breakpoint: string) {
    if (
      breakpoint === 'tablet' ||
      breakpoint === 'mobile' ||
      breakpoint === 'tabletLandscape' ||
      breakpoint === 'smallDesktop'
    ) {
      (this.dom.swiperItems as NodeList).forEach(item => {
        (item as HTMLElement).classList.add('swiper-slide');
      });
      this.initSwiper();
    } else {
      if (this.slidingCardContainer) {
        if (this.slidingCardContainer.destroy) {
          this.slidingCardContainer.destroy();
        }
      }
      (this.dom.swiperItems as NodeList).forEach(item => {
        (item as HTMLElement).classList.remove('swiper-slide');
      });
    }
  }

  initSwiper() {
    Swiper.use([Navigation, Keyboard, Pagination, Controller]);

    this.slidingCardContainer = new Swiper(this.dom.swiperContainer as HTMLElement, {
      pagination: {
        el: this.dom.pagination as HTMLElement,
        type: 'progressbar'
      },
      navigation: {
        nextEl: this.dom.nextButton as HTMLElement,
        prevEl: this.dom.prevButton as HTMLElement
      },
      slidesPerView: 1.22,
      autoHeight: false,
      loop: true
    });
  }
}

export default slidingCardContainer;
